import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

import { Event, EventTracker } from "../../../tracking/service/EventTracker/EventTrackerService";
import { useProgressPercentEffect } from "../Common/hooks/useProgressPercentEffect";
import { useRedirect } from "../Common/hooks/useRedirect";
import { useRegistrationContext } from "../Common/registrationContext";
import { useRegistrationLicenseForm } from "../Common/registrationState";
import { REGISTRATION_PROGRESS_PERCENT, useIsEntity } from "../Common/service";
import { RegistrationPageContainer } from "../RegistrationPageContainer/RegistrationPageContainer";

import { FormProvider } from "./RegistrationLicenseFormContext";
import { RegistrationTechLicenseForm } from "./RegistrationTechLicenseForm";
import { RegistrationVetLicenseForm } from "./RegistrationVetLicenseForm";
import { useSave, useValidate } from "./service";

const RegistrationLicense = () => {
  const registrationLicenseForm = useRegistrationLicenseForm();
  const { save } = useSave();
  const { validate } = useValidate();
  const { redirectToLocation } = useRedirect();
  useProgressPercentEffect(REGISTRATION_PROGRESS_PERCENT.License);

  const {
    registrationContext: { entityId },
    setRegistrationContext,
  } = useRegistrationContext();
  const { isVet } = useIsEntity();

  useEffect(() => {
    if (!registrationLicenseForm.licenses || registrationLicenseForm.licenses.length === 0) {
      setRegistrationContext((prevState) => ({
        registrationContext: {
          ...prevState.registrationContext,
          licenses: [{ licenceNumber: "" }],
        },
      }));
    }
  }, [registrationLicenseForm.licenses, setRegistrationContext]);

  useEffect(() => {
    EventTracker.send({
      eventName: isVet ? Event.Name.VET_VIEW_LICENSE : Event.Name.TECH_VIEW_LICENSE,
      eventType: Event.Type.PAGE_VIEW,
      entityType: isVet ? Event.Entity.VET : Event.Entity.TECH,
      entityId: entityId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RegistrationPageContainer
      linkProps={{ children: "Back to Location", onClick: redirectToLocation }}
    >
      <FormProvider defaultForm={registrationLicenseForm} save={save} validate={validate}>
        {isVet ? <RegistrationVetLicenseForm /> : <RegistrationTechLicenseForm />}
      </FormProvider>
    </RegistrationPageContainer>
  );
};

// eslint-disable-next-line no-restricted-exports
export default withRouter(RegistrationLicense);
